import { useData } from "./DataContext.js";

import Alert from "./Alert.js";

export default function AlertList (props)
{
    const gData = useData();

    const alertList = Object.values(gData.alert).map((alert) => (<Alert key={alert.alertID} variant={alert.variant} title={alert.title} content={alert.content}/>));
    
    return (
	<div className="position-fixed bottom-0 end-0 d-flex flex-column align-items-end" style={{ zIndex: 9999 }}>
	    {alertList}
	</div>
    );
}
